import React from 'react';

import { About, Footer, Header, Skills, Certificate, Testimonial, Work } from './container';
import { Navbar } from './components';
import './App.scss';

const App = () => (
  <div className="app">
    <Navbar />
    <Header />
    <About />
    <Work />
    <Skills />
    <Certificate />
    <Testimonial />
    <Footer />
  </div>
);

export default App;
